import { IconType } from "../../components/Icon";
import { Layout } from "../../components/Layout";
import { Navbar } from "../../components/Navbar";
import { NavigationTitle } from "../../components/NavigationTitle";
import { NotificationSettings } from "../../components/PagesContent/NotificationSettings";

export const NotificationSettingsPage = () => {
  const topBar = (
    <NavigationTitle
      title="notificationSettings"
      iconName="arrowLeft"
      iconType={IconType.default}
    />
  );
  const navBar = <Navbar />;

  return (
    <Layout topBar={topBar} navBar={navBar} includeGaps={false} fixedTop={false}>
      <NotificationSettings />
    </Layout>
  );
};
